import React, { useEffect } from "react";
import { LandingNav, Hero } from "../components/landing/Hero";
import { Pasos, Calculadora } from "../components/landing/Pasos";
import { DineroInvisible, Incluye, Showcase, PantallasCollage } from "../components/landing/Secciones";
import { Contacto, Footer, BloqueFarmaClass } from "../components/landing/Contacto";
import { VideoDemo } from "../components/landing/VideoDemo";

export default function Informacion() {
  useEffect(() => {
    const prev = document.title;
    document.title = "Farmanaliza · Recupera el dinero de tu stock parado";
    document.documentElement.style.scrollBehavior = "smooth";
    return () => { document.title = prev; document.documentElement.style.scrollBehavior = ""; };
  }, []);
  return (
    <div className="bg-white" data-testid="informacion-page">
      <LandingNav />
      <Hero />
      <VideoDemo />
      <PantallasCollage />
      <Pasos />
      <Calculadora />
      <DineroInvisible />
      <Incluye />
      <Showcase />
      <BloqueFarmaClass />
      <Contacto />
      <Footer />
    </div>
  );
}
